import { Injectable } from '@angular/core';
//import { BehaviorSubject, filter, firstValueFrom, Observable } from 'rxjs';
//import { FunctionResult, UserInfoViewModel } from '../models/viewmodels';
//import { environment } from 'src/environments/environment';
//import { AppUser } from '../models/dbmodels';
//import { AuthService } from './auth.service';
import { DataService } from './data-api.service';
//import { ActivatedRoute, ActivatedRouteSnapshot, Data, NavigationEnd, Router } from '@angular/router';
//import { CompanyRoleEnum, UserRoleEnumNumeric } from '../models/lookup-view-models';
import { ApiService } from './api.service';
import {
    EventLogInvalidUserCreateRequest    
} from '../models/viewmodels';


@Injectable({
  providedIn: 'root'
})
export class EventLogService {

  constructor(private dataService: DataService, private apiService: ApiService) {
  }

  invalidUserEeventLogged: EventLogInvalidUserCreateRequest | null = null;

  async createInvalidUserLogoutEvent(evt: EventLogInvalidUserCreateRequest): Promise<void> {

    //do not submit duplicate event logs
    if (this.invalidUserEeventLogged != null &&
        this.invalidUserEeventLogged.ActualValue === evt.ActualValue &&
        this.invalidUserEeventLogged.ExpectedValue === evt.ExpectedValue
    ) {
        console.log('duplicate event log - not submitting', this.invalidUserEeventLogged);
      return;
    }

    this.invalidUserEeventLogged = evt;

    this.dataService.createInvalidUserEventLog(evt);

}

}